import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span>I</span><span>N</span><span>T</span><span>E</span><span>G</span><span>R</span><span>A</span><span>D</span><span>L</span><span>E</span>", 10)
const _hoisted_12 = [
  _hoisted_2
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "A daily math game", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ letters: true, 'hardmode-color': _ctx.isHardmode })
    }, _hoisted_12, 2),
    _hoisted_13
  ]))
}